module.exports = "/images/drive-marker.png?f546229c5ee59f2e33258de6586ba8a9";